import { appConfig } from '../api';

import room1 from '../assets/img/rooms/1.jpg';
import room2 from '../assets/img/rooms/2.jpg';
import room3 from '../assets/img/rooms/3.jpg';
import room4 from '../assets/img/rooms/4.jpg';
import room5 from '../assets/img/rooms/5.jpg';
import room6 from '../assets/img/rooms/6.jpg';
import room7 from '../assets/img/rooms/7.jpg';
import room8 from '../assets/img/rooms/8.jpg';
import room9 from '../assets/img/rooms/9.jpg';

const fallbackRoomImages = {
  1: room1,
  2: room2,
  3: room3,
  4: room4,
  5: room5,
  6: room6,
  7: room7,
  8: room8,
  9: room9,
};

export const getFallbackRoomImage = (roomId) => fallbackRoomImages[Number(roomId)] || room1;

export const getUploadedRoomImageUrl = (imagePath, cacheKey = '') => {
  if (!imagePath) return '';
  if (String(imagePath).startsWith('http')) return imagePath;

  const normalized = String(imagePath).replace(/^\/?uploads\//, '');
  const baseUrl = appConfig.uploadUrl(normalized);
  return cacheKey ? `${baseUrl}?t=${cacheKey}` : baseUrl;
};

export const getRoomImageUrl = (room) => getFallbackRoomImage(room?.id);
